// DS: C37D
import React from 'react';
import PremiumFolderPaywallFullView from './PremiumFolderPaywall';
import WatchersOnlyPaywallFullView from './WatchersOnlyPaywall';
import { PremiumFolderType } from '../../../../types/gallection';
const Paywall = (props)=>{
    var _props_deviation_premiumFolderData;
    switch((_props_deviation_premiumFolderData = props.deviation.premiumFolderData) === null || _props_deviation_premiumFolderData === void 0 ? void 0 : _props_deviation_premiumFolderData.type){
        case PremiumFolderType.Paid:
            return /*#__PURE__*/ React.createElement(PremiumFolderPaywallFullView, props);
        case PremiumFolderType.Watchers:
            return /*#__PURE__*/ React.createElement(WatchersOnlyPaywallFullView, props);
        default:
            return null;
    }
};
Paywall.displayName = 'Paywall';
export default Paywall;
